/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_CreateInputs */

const vi_packaging_material_create = /** @type {(inputs: Packaging_Material_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vật tư`)
};

/**

* @param {Packaging_Material_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_create = /** @type {((inputs?: Packaging_Material_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_create(inputs)
});